module.exports = __webpack_public_path__ + "media/images/application/template/logo-reviews-io-alt-b7b78a1dfacdd55f78fd7a2e71485168.svg";